
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"26","viewBox":"0 0 32 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.352 1.511c1.475 0 2.67 1.598 2.67 3.57v15.543c0 1.971-1.195 3.57-2.67 3.57H4.182c-1.476 0-2.67-1.599-2.67-3.57V5.081c0-1.972 1.194-3.57 2.67-3.57h23.17zm0-1.511H4.182C2.996 0 1.868.602 1.082 1.652.385 2.586 0 3.804 0 5.082v15.543c0 1.278.384 2.495 1.083 3.43.786 1.05 1.915 1.651 3.098 1.651h23.17c1.185 0 2.314-.601 3.1-1.651.697-.935 1.082-2.152 1.082-3.43V5.081c0-1.278-.384-2.496-1.083-3.43C29.666.6 28.536 0 27.352 0z"}}),_c('path',{attrs:{"d":"M10.39 11.125H4.36a.668.668 0 01-.667-.668V5.892c0-.368.299-.667.667-.667h6.029c.368 0 .667.299.667.667v4.565a.667.667 0 01-.667.668zM5.029 9.789h4.693v-3.23H5.03v3.23zM18.782 11.125h-6.03a.668.668 0 01-.667-.668V5.892c0-.368.3-.667.668-.667h6.029c.368 0 .667.299.667.667v4.565c0 .368-.299.668-.668.668zM13.42 9.789h4.694v-3.23H13.42v3.23zM27.173 11.125h-6.03a.668.668 0 01-.667-.668V5.892c0-.368.299-.667.668-.667h6.028c.369 0 .668.299.668.667v4.565a.666.666 0 01-.667.668zm-5.361-1.336h4.694v-3.23h-4.694v3.23zM10.39 20.152H4.36a.668.668 0 01-.667-.668V14.92c0-.368.299-.667.667-.667h6.029c.368 0 .667.299.667.667v4.565a.667.667 0 01-.667.668zm-5.361-1.336h4.693v-3.229H5.03v3.229zM18.782 20.152h-6.03a.668.668 0 01-.667-.668V14.92c0-.368.3-.667.668-.667h6.029c.368 0 .667.299.667.667v4.565c0 .369-.299.668-.668.668zm-5.362-1.336h4.694v-3.229H13.42v3.229zM27.172 14.918h-6.029v4.565h6.03v-4.565z"}}),_c('path',{attrs:{"d":"M27.173 20.244h-6.03a.668.668 0 01-.667-.668v-4.565c0-.368.299-.667.668-.667h6.028c.369 0 .668.299.668.667v4.565a.666.666 0 01-.667.668zm-5.361-1.336h4.694v-3.23h-4.694v3.23z"}})])
          )
        }
      }
    